import { defineAsyncComponent, markRaw } from "vue";
import type { TileConfigType } from "@/modules/tiles/tileConfigs";

export const tileConfigs: TileConfigType = {
  AuditTile: {
    active: true,
    settingsModule: markRaw(defineAsyncComponent(() => import("./tiles/AuditTileSettings.vue"))),
    component: markRaw(defineAsyncComponent(() => import("./tiles/AuditTile.vue"))),
    icon: "fas fa-eye",
  },
};
